import { env } from '../config/env';
import { ApiLocalStorage } from './ApiLocalStorage';

/**
 * Inicializa o localStorage com as variáveis de ambiente necessárias
 * Esta função deve ser chamada antes da renderização da aplicação
 */
export const initializeLocalStorage = () => {
  // Salva o menu padrão no localStorage se estiver definido
  if (env.MENU_DEFAULT) {
    localStorage.setItem('menuDefault', env.MENU_DEFAULT);
  }

  // Salva o campaign ID no localStorage se estiver definido
  if (env.CAMPAIGN_ID) {
    ApiLocalStorage.set('campaign-id', env.CAMPAIGN_ID);
  }

  // Aqui você pode adicionar outras variáveis de ambiente que precisem ser salvas
  // Por exemplo:
  // if (env.API_URL) {
  //   localStorage.setItem('apiUrl', env.API_URL);
  // }
};

/**
 * Obtém o menu padrão do localStorage
 * @returns string | null - O valor do menu padrão ou null se não estiver definido
 */
export const getMenuDefault = (): string | null => {
  return localStorage.getItem('menuDefault');
};

/**
 * Obtém o menu padrão do localStorage com fallback para a variável de ambiente
 * @returns string - O valor do menu padrão ou 'correios' como padrão
 */
export const getMenuDefaultWithFallback = (): string => {
  return getMenuDefault() || env.MENU_DEFAULT || 'engagement';
};

/**
 * Obtém o campaign ID do localStorage
 * @returns string | null - O valor do campaign ID ou null se não estiver definido
 */
export const getCampaignId = (): string | null => {
  return ApiLocalStorage.get('campaign-id');
};

/**
 * Obtém o campaign ID do localStorage com fallback para a variável de ambiente
 * @returns string | null - O valor do campaign ID ou null se não estiver definido
 */
export const getCampaignIdWithFallback = (): string | null => {
  return getCampaignId() || env.CAMPAIGN_ID || null;
};
